import React, { useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Overview from './components/Overview';
import OurMenu from './components/OurMenu';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('overview'); // Default to 'overview'

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'menu':
        return <OurMenu />;
      case 'contact':
        return <ContactUs />;
      default:
        return <Overview />;
    }
  };

  return (
    <ThemeProvider>
      <div className="App">
        <Header activeTab={activeTab} setActiveTab={setActiveTab} />
        <main>
          {renderContent()}
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
